<template>
  <div class="current-controls-wrapper">
    <color-legend :orientation="'horizontal'" class="compare-scale"></color-legend>
    <scale-toggle :grayscale="grayscale" :toggleScale="toggleScale" class="compare-toggle"></scale-toggle>
    <download-button></download-button>
  </div>
</template>

<script>
  import ColorLegend from '../color-legend/ColorLegend';
  import ScaleToggle from '../ScaleToggle';
  import Download from '../Download';

  export default {
    name: 'current-controls',
    props: ['grayscale', 'toggleScale'],
    components: {
      'color-legend': ColorLegend,
      'scale-toggle': ScaleToggle,
      'download-button': Download,
    },
  };
</script>

<style lang="less">
  .current-controls-wrapper {
    display: flex;
    flex-grow: 1;
    box-sizing: border-box;
    height: 32px;
    align-items: center;
    margin-left: 20px;
    justify-content: space-between;
    @media (max-width: 1100px) {
      margin-left: 0;
      margin-bottom: 5px;
    }
    @media(max-width: 500px) {
      flex-direction: column;
      height: 100px;
      margin-left: 0;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
  .small-screen-label {
    display: none;
   @media(max-width: 500px) {
      display: block;
      text-align: center;
    }
  }
  .compare-scale {
    @media (max-width: 500px) {
      order: -1;
      margin-bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// CurrentControls.vue?d0f4c848